import React from 'react';
export const rotulosBaixa = {
  aguardando: 'Aguardando baixa no ERP', parcial: 'Baixa parcial',
  baixado: 'Baixado no ERP', venda_efetivada: 'Venda efetivada no ERP', nao_verificado: 'Não foi possível verificar'
};
const cores = {
  aguardando: 'bg-yellow-100 text-yellow-800', parcial: 'bg-orange-100 text-orange-800',
  baixado: 'bg-green-100 text-green-800', venda_efetivada: 'bg-white text-slate-700 border-2 border-green-500', nao_verificado: 'bg-gray-100 text-gray-700'
};
export default function SituacaoBaixaErp({ dados }) {
  const estado = dados?.situacao_erp || 'nao_verificado';
  return <span className="inline-flex flex-col items-start gap-1">
    <span className={`text-xs px-2 py-1 rounded ${cores[estado] || cores.nao_verificado}`}>{rotulosBaixa[estado] || rotulosBaixa.nao_verificado}</span>
    {dados?.erro_associacao && <span className="text-xs font-semibold text-red-700">Erro de associação identificado. Corrija o vínculo na Conciliação PIX antes de usar este registro para baixa.</span>}
    {dados?.erro_associacao && dados?.parcelas_erp?.filter(p => p.erro_associacao).map(p => <span key={p.ordem_conta} className="text-xs text-red-700">Conta {p.ordem_conta}: {p.motivo}</span>)}
    {dados?.motivo_erp && <span className="text-xs text-gray-500">{dados.motivo_erp}</span>}
    {dados?.venda_erp?.efetivada_em && <span className="text-xs text-gray-500">Efetivação financeira (não confirma recebimento): {new Date(dados.venda_erp.efetivada_em).toLocaleString('pt-BR')}</span>}
    {dados?.consultado_em && <span className="text-xs text-gray-500">Consultado: {new Date(dados.consultado_em).toLocaleString('pt-BR')}</span>}
  </span>;
}
